import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Grid, IconButton, InputAdornment, Tooltip } from "@material-ui/core";
import TexteMultiligne from "../indicateurs/TexteMultiligne";
import DecimalPositif from "../indicateurs/DecimalPositif";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Percent from "../indicateurs/Percent";

const mapStateToProps = (state) => ({
  userRole: state.auth.role,
});

class IrrigPratiquesAgro extends React.Component {
  handleChangeIndicateur = (newIndicateur) => {
    const { changeIndicateur, sousRubriqueIndex, libelleEnglobantIndex } = this.props;
    changeIndicateur(newIndicateur, sousRubriqueIndex, libelleEnglobantIndex);
  };

  render() {
    const { indicateurs, computedFields, getValueAssolement } = this.props;

    const indicateursKeys = ["HVE4_IRRI_D_51", "HVE4_IRRI_I_5", "HVE4_IRRI_S_5"];

    const indicateursToDisplay = Object.values(
      Object.fromEntries(Object.entries(indicateurs).filter(([key]) => indicateursKeys.includes(key)))
    );

    if (indicateursToDisplay.length > 0)
      return (
        <React.Fragment>
          <Grid container spacing={2} item>
            <Grid container item xs={12} className={"d-flex align-items-center"}>
              <div className={indicateurs["HVE4_IRRI_D_50"].afficherGras ? "mr-3 bold" : "mr-3"}>
                {indicateurs["HVE4_IRRI_D_50"].libelle}
              </div>
              <Tooltip
                title={<span style={{ whiteSpace: "pre-line" }}>{indicateurs["HVE4_IRRI_D_50"].messageAide}</span>}
              >
                <IconButton>
                  <FontAwesomeIcon icon="info-circle" />
                </IconButton>
              </Tooltip>
              <TexteMultiligne
                getValueAssolement={getValueAssolement}
                indicateur={indicateurs["HVE4_IRRI_D_50"]}
                key={"indicateur-" + indicateurs["HVE4_IRRI_D_50"].idIndicateur}
                changeIndicateur={this.handleChangeIndicateur}
                inputProps={{
                  multiline: true,
                  fullWidth: true,
                  style: {
                    minWidth: "10rem",
                    maxWidth: "55rem",
                  },
                  rows: 4,
                  rowsMax: 4,
                  fontWeight: indicateurs["HVE4_IRRI_D_30"].afficherGras ? "bold" : "normal",
                }}
                valueInputProps={
                  indicateurs["HVE4_IRRI_D_50"].libelleUnite != null && {
                    endAdornment: (
                      <InputAdornment position={"end"}>{indicateurs["HVE4_IRRI_D_50"].libelleUnite}</InputAdornment>
                    ),
                  }
                }
                computedFields={computedFields}
              />
            </Grid>

            <Grid item xs={4}>
              <div className={indicateurs["HVE4_IRRI_D_51"].afficherGras ? "mr-3 bold" : "mr-3"}>
                {indicateurs["HVE4_IRRI_D_51"].libelle}
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className={indicateurs["HVE4_IRRI_I_5"].afficherGras ? "mr-3 bold" : "mr-3"}>
                {indicateurs["HVE4_IRRI_I_5"].libelle}
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className={indicateurs["HVE4_IRRI_S_5"].afficherGras ? "mr-3 bold" : "mr-3"}>
                {indicateurs["HVE4_IRRI_S_5"].libelle}
              </div>
            </Grid>

            <Grid item xs={4}>
              <DecimalPositif
                error={
                  (indicateurs["HVE4_IRRI_D_51"]?.valeur?.value ?? 0) >
                  (indicateurs["HVE4_IRRI_D_102"]?.valeur?.value ?? 0)
                }
                helperText={
                  (indicateurs["HVE4_IRRI_D_51"]?.valeur?.value ?? 0) >
                  (indicateurs["HVE4_IRRI_D_102"]?.valeur?.value ?? 0)
                    ? "La valeur saisie ne doit pas dépasser la surface irriguée"
                    : ""
                }
                size={"small"}
                getValueAssolement={getValueAssolement}
                indicateur={indicateurs["HVE4_IRRI_D_51"]}
                key={"indicateur-" + indicateurs["HVE4_IRRI_D_51"].idIndicateur}
                changeIndicateur={this.handleChangeIndicateur}
                valueInputProps={
                  indicateurs["HVE4_IRRI_D_51"].libelleUnite != null && {
                    endAdornment: (
                      <InputAdornment position={"end"}>{indicateurs["HVE4_IRRI_D_51"].libelleUnite}</InputAdornment>
                    ),
                  }
                }
                computedFields={computedFields}
              />
            </Grid>
            <Grid item xs={4}>
              <Percent
                size={"small"}
                getValueAssolement={getValueAssolement}
                indicateur={indicateurs["HVE4_IRRI_I_5"]}
                key={"indicateur-" + indicateurs["HVE4_IRRI_I_5"].idIndicateur}
                changeIndicateur={this.handleChangeIndicateur}
                valueInputProps={
                  indicateurs["HVE4_IRRI_I_5"].libelleUnite != null && {
                    endAdornment: (
                      <InputAdornment position={"end"}>{indicateurs["HVE4_IRRI_I_5"].libelleUnite}</InputAdornment>
                    ),
                  }
                }
                computedFields={computedFields}
              />
            </Grid>
            <Grid item xs={4} className={"total-point"}>
              <DecimalPositif
                size={"small"}
                getValueAssolement={getValueAssolement}
                indicateur={indicateurs["HVE4_IRRI_S_5"]}
                key={"indicateur-" + indicateurs["HVE4_IRRI_S_5"].idIndicateur}
                changeIndicateur={this.handleChangeIndicateur}
                valueInputProps={
                  indicateurs["HVE4_IRRI_S_5"].libelleUnite != null && {
                    endAdornment: (
                      <InputAdornment position={"end"}>{indicateurs["HVE4_IRRI_S_5"].libelleUnite}</InputAdornment>
                    ),
                  }
                }
                computedFields={computedFields}
              />
            </Grid>
          </Grid>
        </React.Fragment>
      );
  }
}

export default compose(withTranslation(), connect(mapStateToProps))(IrrigPratiquesAgro);
